// EN
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Bulk edit",
    cfgTitle: "Calendar settings",
    syncSection: "Synchronization",
    resyncOta: "Re-sync with OTA",
    resyncOtaSub: "Push availability and rates back to the channel.",
  },
  mode: {
    calendar: "Calendar",
    rates: "Rates",
  },
  search: {
    placeholder: "Search guest or code…",
    clear: "Clear",
    go: "Search",
    resultsHint: "{count} results — select one:",
    combo: "Combined · {count} rooms",
  },
  header: {
    occupancy: "Occupancy {pct}%",
  },
  type: {
    roomsAbbr: "rooms",
    configTitle: "Room type settings (OTA and arrival/departure rules)",
    otaConnected: "OTA connected",
    subscribeToConnect: "Subscribe to connect OTAs",
  },
  rtCell: {
    editTooltip: "Click to edit availability, price, minimum stay and closure",
    overbookRisk: "Overbooking risk",
    closedTag: "Closed",
  },
  rules: {
    sameDayCutoff: "Same-day sales cutoff at {time}",
  },
  organizeRow: {
    title: "To organize",
    unplacedCount: "{count} unplaced booking | {count} unplaced bookings",
    autoTooltip: "Automatically rearranges bookings across rooms so they all fit",
    organizing: "Organizing…",
    organize: "Organize",
  },
  footer: {
    available: "Available",
    unavailable: "Unavailable",
    closed: "Closed",
    overbookRisk: "Overbooking risk",
    realtime: "Values update in real time",
    timezone: "Time zone: {tz}",
  },
  dayEdit: {
    oneDay: "one day",
    open: "Open",
    closed: "Closed",
    priceLabel: "Price · standard rate",
    minStayLabel: "Minimum stay (nights)",
    forSaleLabel: "Rooms for sale",
    forSaleHint: "cap · max {max}",
    applyMultiple: "Apply to several dates?",
    cancel: "Cancel",
    saving: "Saving…",
    save: "Save",
  },
  roomMenu: {
    create: "Create booking",
    createSub: "Booking for the selected range",
    block: "Block 1 room",
    blockSub: "Close this room for the range",
    unblock: "Remove block",
    unblockSub: "Reopen this room for the range",
    oos: "Out of service",
    oosSub: "Maintenance for this room",
  },
  closureMenu: {
    turnoverTitle: "Set by the turnaround time",
    turnoverSub: "It moves with the booking dates and disappears if it is cancelled.",
    changeRule: "Change the rule",
    changeRuleSub: "Adjust or disable the turnaround time",
    editReason: "Edit reason",
    editReasonSub: "Change the block reason",
    changeRoom: "Change room",
    changeRoomSub: "Move to another room of the type",
    unblock: "Remove block",
    unblockSub: "Reopen and free up the space",
    moveTo: "Move to…",
    noOtherRooms: "There are no other rooms in this type.",
    barTooltip: "Block: {reason} — click to edit or remove",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "Manage OTA connection",
    connectOta: "Connect OTA",
    otaSub: "Sync the property with the OTAs",
    arrivalRules: "Arrival and departure rules",
    arrivalRulesSub: "Allowed check-in / check-out days",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Sold by the hour",
    soldOne: "Sold by the hour · {range}",
    soldMany: "Sold by the hour · {count} stays",
  },
  tooltip: {
    past: "Past",
    unassignedHtml: "<strong>No room assigned.</strong> Availability is spread across rooms. Use <strong>Organize</strong> to rearrange it automatically, or click and assign it a room.",
    nights: "{count} night | {count} nights",
    guests: "{count} guest | {count} guests",
  },
  channels: {
    direct: "Direct",
  },
  syncModal: {
    title: "Sync with the OTA",
    message: "Availability and the maximum stay of this calendar will be recalculated and resent to the OTA.",
    confirm: "Yes, sync",
    cancel: "Cancel",
  },
  syncTooltip: {
    can: "Recalculates and resends availability and maximum stay to the OTA (prevents overbooking).",
    cannot: "Connect the property to a channel to be able to sync.",
  },
  block: {
    editTitle: "Edit reason",
    createTitle: "Block room",
    reasonLabel: "Block reason",
    reasonHint: "(it will be shown on the calendar)",
    placeholder: "e.g. Maintenance, owner use…",
    cancel: "Cancel",
    saving: "Saving…",
    saveReason: "Save reason",
    blockBtn: "Block",
    defaultReason: "Blocked",
    thisRoom: "this room",
    editReasonMsg: `Edit the block reason for "{room}" ({count} night). | Edit the block reason for "{room}" ({count} nights).`,
    createMsg: `"{room}" ({unit}) will be closed for {count} night. It will not be bookable on those dates; the other rooms of the type remain available. | "{room}" ({unit}) will be closed for {count} nights. It will not be bookable on those dates; the other rooms of the type remain available.`,
    presets: {
      maintenance: "Maintenance",
      ownerUse: "Owner use",
      renovation: "Renovation",
      deepCleaning: "Deep cleaning",
      externalReserved: "Reserved (external)",
    },
  },
  organizeModal: {
    title: "Organize automatically",
    bodyHtml: `We will find the best fit and <strong>rearrange the bookings across the rooms</strong> of this type so that <strong>{count} unplaced booking fits</strong> back to back. | We will find the best fit and <strong>rearrange the bookings across the rooms</strong> of this type so that <strong>{count} unplaced bookings fit</strong> back to back.`,
    point1Html: "Only the assigned <strong>physical room</strong> changes.",
    point2Html: "<strong>Dates, prices and guests</strong> are not touched.",
    point3: "If any does not fit back to back, we will let you know.",
    cancel: "Cancel",
    organizing: "Organizing…",
    confirm: "Yes, organize",
  },
  empty: {
    noHotelTitle: "No hotel-type listings",
    noHotelSubHtml: "Create a <strong>Hotel</strong> or <strong>Camping</strong> listing to start managing availability by room.",
    noHotelBtn: "Go to listings",
    noRoomsTitle: "{name} has no rooms",
    noRoomsSub: "This listing does not have any rooms registered yet. Add rooms from the listing settings to see the calendar.",
    noRoomsBtn: "Configure listing",
  },
  mock: {
    today: "Today",
    month: "MAY 2026",
    searchPlaceholder: "Search by name or code…",
    searchBtn: "Search",
    createBtn: "Create booking",
    na: "N/A",
    forSaleLabel: "Avail. for sale",
    suiteDeluxe: "Deluxe Suite",
    standardRoom: "Standard Room",
    roomsCount2: "(2 rooms)",
    roomsCount3: "(3 rooms)",
    no: "No.",
    room101: "Room 101",
    room102: "Room 102",
    room201: "Room 201",
    room202: "Room 202",
    room203: "Room 203",
    d1: "Mon 1",
    d2: "Tue 2",
    d3: "Wed 3",
    d4: "Thu 4",
    d5: "Fri 5",
    d6: "Sat 6",
    d7: "Sun 7",
    d8: "Mon 8",
    d9: "Tue 9",
    d10: "Wed 10",
    d11: "Thu 11",
    d12: "Fri 12",
  },
  ops: {
    closingDay: "Closing day…",
    openingDay: "Opening day…",
    saving: "Saving…",
    movingBlock: "Moving block…",
    swappingBlockReservation: "Swapping block and booking…",
    swappingReservationBlock: "Swapping booking and block…",
    swappingRooms: "Swapping rooms…",
    changingRoom: "Changing room…",
    organizingRooms: "Organizing rooms…",
    syncingWithOta: "Syncing calendar with the OTA…",
    processing: "Processing…",
    settingMaintenance: "Putting into maintenance…",
    clearingMaintenance: "Removing maintenance…",
    updatingAvailability: "Updating availability…",
    updatingReason: "Updating reason…",
    closingRoom: "Closing room…",
    removingBlock: "Removing block…",
  },
  toasts: {
    dayClosed: "Day closed",
    dayOpened: "Day opened",
    availabilityUpdateErr: "Availability could not be updated",
    dayUpdated: "Day updated",
    daySaveErr: "The day could not be saved",
    moveTargetMultipleReservations: "The target has several bookings in that range; move them manually.",
    roomRejectsBlock: "That room does not accept the block in that range",
    blockMoved: "Block moved to another room",
    blockMoveErr: "The block could not be moved",
    swapStartErr: "The swap could not be started",
    reservationNoFitSwap: "The booking does not fit in the other room for its whole range; it could not be swapped.",
    reservationMoveErr: "The booking could not be moved",
    swapCompleteErr: "The swap could not be completed (it was reverted)",
    blockReservationSwapped: "Block and booking swapped",
    swapErr: "The swap could not be completed",
    rangeHasOccupiedOrClosed: "The range includes occupied or closed nights in this room.",
    organizeErr: "It could not be organized automatically.",
    organizeNothing: "There was nothing to reorganize.",
    organizePartial: "{done} booking(s) were organized, but {unplaced} do not fit back to back in any combination.",
    organizeDoneAssigned: "Calendar organized: {assigned} assigned",
    organizeDoneMoved: ", {moved} moved to another room",
    swapGroupDone: "Group swap completed: {groupCount} ⇄ {swappedCount} bookings.",
    roomsSwappedWith: "Rooms swapped with {names}.",
    noPropertyToSync: "There is no property to sync.",
    calendarResynced: "Calendar recalculated and synced with the OTA.",
    syncErr: "The calendar could not be synced with the OTA.",
    genericError: "Error",
    reservationNoFitSwapStrict: "It could not be swapped: the booking is not free for its whole range.",
    reservationBlockSwapped: "Booking and block swapped",
    roomCloseErr: "The room could not be closed",
    reasonUpdated: "Reason updated",
    roomClosedInRange: "Room closed for the range",
    blockRemoved: "Block removed",
    blockRemoveErr: "The block could not be removed",
    searchMinChars: "Type at least 2 characters to search",
    searchNoResults: "No bookings were found for that search",
    searchErr: "Error searching for bookings",
  },
  summary: {
    stateAvailable: "Available",
    stateClosed: "Closed",
    stateNoDisp: "N/A",
  },
};
